import clsx from 'clsx';
import React from 'react';

function BuilderFieldGrid({
    children,
    className,
}: {
    children: React.ReactNode;
    className?: string;
}) {
    return (
        <div className={clsx('grid gap-3 md:grid-cols-2', className)}>
            {children}
        </div>
    );
}

function BuilderField({
    label,
    helperText,
    children,
    className,
    contentClassName,
}: {
    label: string;
    helperText?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
    contentClassName?: string;
}) {
    return (
        <div
            className={clsx(
                'rounded-2xl border border-slate-200 bg-slate-50 p-4',
                className,
            )}
        >
            <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
                {label}
            </p>
            {helperText && (
                <p className="mt-1 text-xs leading-5 text-slate-400">
                    {helperText}
                </p>
            )}
            <div className={clsx('mt-3', contentClassName)}>{children}</div>
        </div>
    );
}

export { BuilderField, BuilderFieldGrid };
